import Header from '../../../components/Header'
import BrainDestination from '../../../components/BrainDestination'

export default function Destination() {
  return (
    <>
        <Header/>
        <BrainDestination/>
    </>
  )
}